/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integrations_Permission_DescriptionInputs */



/**
* | output |
* | --- |
* | "Switched off, nobody in your organization can use this integration — regardless of who has access or what is configured. Nothing is deleted; switching it bac..." |
*
* @param {Integrations_Permission_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const integrations_permission_description = /** @type {((inputs?: Integrations_Permission_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integrations_Permission_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ausgeschaltet kann niemand in Ihrer Organisation diese Integration nutzen – unabhängig davon, wer Zugriff hat oder was konfiguriert ist. Es wird nichts gelöscht; beim Wiedereinschalten gilt der vorherige Stand.")
	return /** @type {LocalizedString} */ ("Switched off, nobody in your organization can use this integration — regardless of who has access or what is configured. Nothing is deleted; switching it back on restores the previous state.")
});